<template>
    <!-- Mobile -->
    <header class="header-mobile" :class="{'is-active': mobileActive}" v-if="isMobile" ref="menu">
      <div class="header-mobile__icon" @click="onClickHeaderIcon"></div>
      <div class="header-mobile__wrapper">
        <div class="header-mobile__inner">
          <div class="header-mobile__nav">
            <router-link to="/" class="header-mobile__title">lof</router-link>
            <router-link to="/shop" class="header-mobile__nav__link">Shop</router-link>
            <router-link to="/warriors" class="header-mobile__nav__link">Warriors</router-link>
            <router-link to="/articles" class="header-mobile__nav__link">Articles</router-link>
            <router-link to="/about" class="header-mobile__nav__link">About</router-link>
            <router-link to="/contact" class="header-mobile__nav__link">Contact</router-link>
          </div>
          <div class="header-mobile__search">
            <a @click="onToggleSearch" class="header-mobile__search__text">Search</a>
          </div>
          <div class="header-mobile__newsletter" v-if="content">
            <p class="header-mobile__newsletter__text" v-html="content.subscribe"></p>
            <div class="header-mobile__newsletter__button">
              <div class="header-mobile__newsletter__buttons__input" :class="{'is-loading': mail.loading}">
                  <input class="link--btn" placeholder="your email" aria-label="email field" ref="input">
                  <button class="input--btn__ok" @click="onClickSubscribe">
                      <span v-if="!mail.loading">Ok</span>
                      <span v-else class="input--btn__ok__spinner"></span>
                  </button>
              </div>
              <div class="footer__buttons__newsletter__text" :class="{'has-error': mail.type === 'error', 'has-success': mail.type === 'success'}" v-if="mail.message">
                  {{ mail.message }}
              </div>
            </div>
          </div>
          <div class="header-mobile__social" v-if="content">
            <a v-for="(item, index) in content.social_links" :key="index" class="header-mobile__social__link link" :href="item.url">
              {{ item.text }}
            </a>
          </div>
        </div>
      </div>
    </header>
    <!-- desktop -->
    <header v-else class="header" :class="{'is-translated': translated}">
      <AppGrainBg v-if="isGrey"/>
      <div class="header__wrapper">
        <nav class="header__nav container--full">
          <router-link to ="/" class="header__nav__logo" v-if="!showBack">lof</router-link>
          <router-link :to="{path: showBack, query: backQuery}" class="header__back header__nav__link" v-if="showBack">Back</router-link>
          <router-link to="/shop" class="header__nav__link">Shop</router-link>
          <router-link to="/warriors" class="header__nav__link">Warriors</router-link>
          <router-link to="/articles" class="header__nav__link">Articles</router-link>
          <router-link to="/about" class="header__nav__link">About</router-link>
          <router-link to="/contact" class="header__nav__link">Contact</router-link>
          <a @click="onToggleSearch" class="header__search header__nav__link">Search</a>
        </nav>
      </div>
    </header>
</template>

<script>
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

import AppGrainBg from '@/components/AppGrainBg.vue'

import EventHub from '@/utils/EventHub'

export default {
  name: 'app-header',

  components: {
    AppGrainBg
  },

  data() {
    return {
      content: null,
      isMobile: true,
      mobileActive: false,
      translated: false,
      showBack: false,
      bQuery: null,
      isGrey: false,
      mail: {
          loading: false,
          message: null,
          type: null
      }
    }
  },

  computed: {
    backQuery()
    {
      const obj = this.bQuery ? {
        ...this.$route.query,
        ...this.bQuery
      } : {}

      return  obj
    }
  },

  created() {
    this.directionChanged = false
    this.translateOffset = 100
    this.scrollChangedAt = 0

    this.scroll = {
      last: 0,
      top: 0,
      direction: -1
    }

    if(this.isMobile)
    {
      this.initMobile()
    }

    this.addListeners()
  },

  mounted() {
    this.onResize({width: window.innerWidth, height: window.innerHeight})
  },

  destroyed() {
    this.removeListeners()
    clearAllBodyScrollLocks()
  },

  methods: {
    addListeners()
    {
      EventHub.$on('application:on-route-change', this.onRouteChange)
      EventHub.$on('window:resize', this.onResize)
      EventHub.$on('header:set-back-query', this.onSetBackQuery)
      EventHub.$on('application:on-scroll', this.onScroll)
    },

    removeListeners()
    {
      EventHub.$off('application:on-route-change', this.onRouteChange)
      EventHub.$off('window:resize', this.onResize)
      EventHub.$off('header:set-back-query', this.onSetBackQuery)
      EventHub.$off('application:on-scroll', this.onScroll)
    },

    initMobile()
    {
      const endpoint = '/wp-json/acf/v3/pages/39'

      fetch(process.env.VUE_APP_WP_API + endpoint)
        .then((res) => res.json())
        .then((res) =>
        {
            this.content = res.acf
        })
    },

    onSetBackQuery(query)
    {
      this.bQuery = {
        page: query.page,
        col: query.col,
        item: query.item
      }
    },

    onRouteChange(to)
    {
      // console.log('on route change', to)
      this.showBack = to.meta.goBack

      this.onScroll()

      this.isGrey = to.meta.grey

      if(this.isMobile)
      {
        this.$el.classList.add('no-transition')
        this.mobileActive = false
        this.$el.classList.remove('no-transition')
        enableBodyScroll(this.$refs.menu)
      }
    },

    onScroll()
    {
      this.scroll.top = window.pageYOffset || document.documentElement.scrollTop

      let direction = 1

      if(this.scroll.top > this.scroll.last)
      {
        direction = 1
      }
      else
      {
        direction = -1
      }

      if(!(direction === this.scroll.direction) && !(this.directionChanged))
      {
        this.directionChanged = true
        this.scrollChangedAt = this.scroll.top
      }

      if(this.directionChanged && Math.abs(this.scroll.top - this.scrollChangedAt) > this.translateOffset)
      {
        if(direction === 1)
        {
          this.translated = true
        }
        else
        {
          this.translated = false
        }

        this.directionChanged = false
      }

      this.scroll.direction = direction
      this.scroll.last = this.scroll.top
    },

    onClickHeaderIcon()
    {
      this.mobileActive = !this.mobileActive

      if(this.mobileActive)
      {
        disableBodyScroll(this.$refs.menu)
      }
      else
      {
        enableBodyScroll(this.$refs.menu)
      }
    },

    onToggleSearch()
    {
      EventHub.$emit('application:toggle-search', true)
    },

    onResize(windowObj)
    {
      if(windowObj.width <= 768)
      {
        this.isMobile = true
      }
      else
      {
        this.isMobile = false
      }
    },

    onToggleMobile(isMobile)
    {
      this.isMobile = isMobile
    },

    onClickSubscribe()
    {
      if(this.$refs.input.value.length === 0 || this.mail.loading)
          return

      const url = process.env.VUE_APP_WP_API + '/subscribe/subscribe.php'

      this.mail.type = null
      this.mail.message = null

      let formData = new FormData()
      formData.append('email', this.$refs.input.value)

      this.mail.loading = true

      fetch(url, 
      {
          method: 'POST', 
          body: formData
      })
      .then((res) => res.json())
      .then((res) =>
      {
          this.$refs.input.value = ''

          this.mail.loading = false

          if(res.error === 0)
          {
              this.mail.type = 'success'
              this.mail.message = 'You are now registered!'

              setTimeout(() => {
                  this.mail.type = null
                  this.mail.message = null
              }, 5000)
          }
          else
          {
              this.mail.type = 'error'
              this.mail.message = res.detail
          }
      })
    }
  }
}
</script>

<style lang="stylus">
.header
  z-index 5
  overflow hidden
  position fixed
  top 0
  width 100vw
  background-color $beige
  // overflow hidden
  transform translateY(0)
  transition transform 0.6s $ease-out-quint

  .is-grey &
    background-color $grey


  &:after
    content ''
    z-index -1
    position absolute
    top 0
    width 100%
    height 100%
    opacity 0
    box-shadow 0px 12.5px 20px 0 rgba(0, 0, 0, 0.03)

  &.is-translated
    transform translateY(-100%)

.header__wrapper
  // height 90px
  position relative
  z-index 3
  interpolate('height', 768px, 2560px, 60px, 140px);
  transform translateY(0)
  // transition transform 0.6s $ease-out-quint

  // .is-translated &
  //   transform translateY(100%)

.header__nav__link
  cursor pointer
  position relative
  margin-right 30px
  text-transform uppercase
  line-height 2
  letter-spacing 0.1em
  interpolate('font-size', 1600px, 2560px, 20px, 25px);

  @media(max-width 1600px)
    interpolate('font-size', 768px, 1600px, 13px, 20px);



  &:after
    content ''
    position absolute
    bottom 0
    left 0
    width 100%
    height 1px
    background-color $black
    transform-origin center right
    transform scaleX(0) scaleY(1.2)
    transition transform 0.4s $ease-in-out-circ

  &:nth-last-child(2), &:last-child
    margin-right 0

  &:hover, &.router-link-active
    &:after
      transform scaleX(1) scaleY(1.2)
      transform-origin center left

.header__nav
  height 100%
  display flex
  justify-content center
  align-items center

.header__nav__logo
  cursor pointer
  position absolute 
  left 0
  text-transform uppercase
  font-family 'Sabon'
  interpolate('font-size', 1600px, 2560px, 52px, 75px);

  @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 28px, 52px);

.header__back
  cursor pointer
  position absolute 
  left 0px

.header__search
  position absolute 
  right 0px


// MOBILE
.header-mobile
  z-index 6
  position fixed
  pointer-events none
  top 0
  left 0
  width 100%
  height 100vh

  &.is-active
    overflow-y scroll
    pointer-events all

.header-mobile__icon
  z-index 5
  pointer-events all
  position absolute
  top $space-y-mobile
  right $space-x-mobile
  height 12px
  width 26px

  &:before, &:after
    content ''
    position absolute
    left 0
    width 100%
    height 2px
    background $black

  &:before
    top 0

  &:after
    bottom 0

  .is-active &
    &:before, &:after
      top 50%
      transform-origin 50% 50%

    &:before
      transform rotate(45deg) 

    &:after
      bottom auto
      transform rotate(-45deg) 

.header-mobile__wrapper
  width 100%
  height auto
  overflow-x hidden
  background-color $beige
  transform translate3d(100%, 0, 0)
  transition transform 0.6s $ease-in-out-circ

  .is-active &
    transform translate3d(0, 0, 0)

  .no-transition &
    transition transform 0s

.header-mobile__inner
  transform translate3d(-100%, 0, 0)
  transition transform 0.6s $ease-in-out-circ

  .is-active &
    transform translate3d(0, 0, 0)
  
  .no-transition &
    transition transform 0s

.header-mobile__nav
  padding $space-y-mobile $space-x-mobile 30px $space-x-mobile
  display flex
  flex-direction column
  align-items flex-start
  border-bottom 1px solid $black

.header-mobile__title
  margin-bottom 80px
  font-size 45px
  letter-spacing 0.05em
  font-family 'Sabon'
  line-height 1
  text-transform uppercase

.header-mobile__nav__link
  padding-bottom 10px
  display inline-block
  text-transform uppercase

.header-mobile__search
  width 100%
  border-bottom 1px solid $black

.header-mobile__search__text
  padding 40px 0px 40px $space-x-mobile
  display block
  text-transform uppercase
  line-height 1

.header-mobile__newsletter
  padding 60px $space-x-mobile 50px $space-x-mobile
  border-bottom 1px solid $black

.header-mobile__newsletter__text
  padding-bottom 40px
  text-transform uppercase
  line-height 0.9
  font-size 27px

.header-mobile__newsletter__button
  width 80%
  position relative
  display flex
  flex-direction column

  .link--btn
    width 100%

  .input--btn__ok
    border-left 0

.header-mobile__newsletter__buttons__input
  width 100%
  display flex

.header-mobile__social
  padding 30px $space-x-mobile
  display flex
  flex-wrap wrap

.header-mobile__social__link
  padding-right 20px
  line-height 1

</style>